import React, { useState } from "react"
import { api } from "aldoo-ra/API"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import Input from "aldoo-ra/Input"
import TextBundle from "aldoo-ra/CMS/text-bundle"

// Public endpoint — "newsletter" itself is the admin action map
const newsletterAPI = api("newsletter/manage")

export default function NewsletterSection() {
  const texts = TextBundle({ id: "home_subscription_section" })
  const [email, setEmail] = useState("")
  const [state, setState] = useState("idle") // idle | sending | done | error

  const subscribe = async (event) => {
    event.preventDefault()
    if (!email.trim() || state === "sending") return
    setState("sending")
    try {
      const res = await newsletterAPI({ subscribe: { email: email.trim() } })
      setState(res?.error ? "error" : "done")
    } catch {
      setState("error")
    }
  }

  return (
    <section className="max-w-5xl text-center bg-gradient-to-br from-primary/10 via-secondary/15 to-secondary/30 rounded-[30px] md:rounded-[50px] lg:rounded-[70px] px-8 py-20 mb-20 mx-4 lg:mx-auto">
      <Typography
        component="h2"
        variant="h1"
      >
        {texts?.section_title}
      </Typography>

      <Typography
        variant="body1_dim"
        className="mt-3"
      >
        {texts?.section_subtitle}
      </Typography>

      {state === "done" ? (
        <Typography
          variant="txt_accent"
          className="block text-primary_dk mt-8"
        >
          {texts?.success_message}
        </Typography>
      ) : (
        <form onSubmit={subscribe} className="mt-8 flex flex-col sm:flex-row gap-3 justify-center">
          <Input
            type="email"
            variant="snap"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={texts?.email_placeholder}
            className="w-full sm:w-80"
          />

          <Button
            variant="primary_m"
            type="submit"
            disabled={state === "sending"}
          >
            {state === "sending" ? texts?.subscribing_button : texts?.subscribe_button}
          </Button>
        </form>
      )}
      {state === "error" && (
        <p className="mt-3 text-sm text-error">
          {texts?.error_message}
        </p>
      )}
    </section>
  )
}
